<template>
  <div
    id="app"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <top class="top"></top>
    <right-contact class="rightContact"></right-contact>
    <router-view />
    <foote class="bottom"></foote>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import foote from "@/components/foote.vue";
import rightContact from "@/components/rightContact.vue";
export default {
  name: "App",
  components: { top, foote, rightContact },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    "$route.path": {
      handler(val) {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 780);
      },
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  .top {
    position: fixed;
    top: 0px;
    z-index: 999;
  }
  .rightContact {
    position: fixed;
    right: 0px;
    top: 400px;
    z-index: 9999;
  }
}
::-webkit-scrollbar {
  width: 5px; /* 纵向滚动条*/
  height: 5px; /* 横向滚动条 */
  background-color: #fff;
  margin-left: 30px;
}

/*定义滚动条轨道 内阴影*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  background-color: #ccc;
}

/*定义滑块 内阴影*/
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  background-color: #afafb1;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue